import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { create } from 'actions/data'
import { Hidden } from '@material-ui/core'
import Mobile from './Mobile'
import Desktop from './Desktop'

class CustomForm extends Component {
  render() {
    return (
      <>
        <Hidden smDown>
          <Desktop />
        </Hidden>
        <Hidden mdUp>
          <Mobile />
        </Hidden>
      </>
    )
  }
}

export default connect(null, (dispatch) =>
  bindActionCreators({ create }, dispatch),
)(CustomForm)
